/**
 * Auto-generated currencies dataset — DO NOT EDIT MANUALLY.
 * Generated: 2026-07-14T15:38:23.356Z
 */

import type { ICurrency } from '../types';

export const CURRENCIES: ICurrency[] = [
  {
    "code": "AFN",
    "name": "Afghan afghani",
    "symbol": "؋",
    "countryCode": "AF",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "AX",
    "precision": 2
  },
  {
    "code": "ALL",
    "name": "Albanian lek",
    "symbol": "Lek",
    "countryCode": "AL",
    "precision": 0
  },
  {
    "code": "DZD",
    "name": "Algerian dinar",
    "symbol": "دج",
    "countryCode": "DZ",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "AS",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "AD",
    "precision": 2
  },
  {
    "code": "AOA",
    "name": "Angolan kwanza",
    "symbol": "Kz",
    "countryCode": "AO",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "AI",
    "precision": 2
  },
  {
    "code": "AAD",
    "name": "Antarctican dollar",
    "symbol": "$",
    "countryCode": "AQ",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "AG",
    "precision": 2
  },
  {
    "code": "ARS",
    "name": "Argentine peso",
    "symbol": "$",
    "countryCode": "AR",
    "precision": 2
  },
  {
    "code": "AMD",
    "name": "Armenian dram",
    "symbol": "֏",
    "countryCode": "AM",
    "precision": 2
  },
  {
    "code": "AWG",
    "name": "Aruban florin",
    "symbol": "ƒ",
    "countryCode": "AW",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "AU",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "AT",
    "precision": 2
  },
  {
    "code": "AZN",
    "name": "Azerbaijani manat",
    "symbol": "m",
    "countryCode": "AZ",
    "precision": 2
  },
  {
    "code": "BHD",
    "name": "Bahraini dinar",
    "symbol": ".د.ب",
    "countryCode": "BH",
    "precision": 3
  },
  {
    "code": "BDT",
    "name": "Bangladeshi taka",
    "symbol": "৳",
    "countryCode": "BD",
    "precision": 2
  },
  {
    "code": "BBD",
    "name": "Barbadian dollar",
    "symbol": "Bds$",
    "countryCode": "BB",
    "precision": 2
  },
  {
    "code": "BYN",
    "name": "Belarusian ruble",
    "symbol": "Br",
    "countryCode": "BY",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "BE",
    "precision": 2
  },
  {
    "code": "BZD",
    "name": "Belize dollar",
    "symbol": "$",
    "countryCode": "BZ",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "BJ",
    "precision": 0
  },
  {
    "code": "BMD",
    "name": "Bermudian dollar",
    "symbol": "$",
    "countryCode": "BM",
    "precision": 2
  },
  {
    "code": "BTN",
    "name": "Bhutanese ngultrum",
    "symbol": "Nu.",
    "countryCode": "BT",
    "precision": 2
  },
  {
    "code": "BOB",
    "name": "Bolivian boliviano",
    "symbol": "Bs.",
    "countryCode": "BO",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "BQ",
    "precision": 2
  },
  {
    "code": "BAM",
    "name": "Bosnia and Herzegovina convertible mark",
    "symbol": "KM",
    "countryCode": "BA",
    "precision": 2
  },
  {
    "code": "BWP",
    "name": "Botswana pula",
    "symbol": "P",
    "countryCode": "BW",
    "precision": 2
  },
  {
    "code": "NOK",
    "name": "Norwegian krone",
    "symbol": "ko",
    "countryCode": "BV",
    "precision": 2
  },
  {
    "code": "BRL",
    "name": "Brazilian real",
    "symbol": "R$",
    "countryCode": "BR",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "IO",
    "precision": 2
  },
  {
    "code": "BND",
    "name": "Brunei dollar",
    "symbol": "B$",
    "countryCode": "BN",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "BG",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "BF",
    "precision": 0
  },
  {
    "code": "BIF",
    "name": "Burundian franc",
    "symbol": "FBu",
    "countryCode": "BI",
    "precision": 0
  },
  {
    "code": "KHR",
    "name": "Cambodian riel",
    "symbol": "KHR",
    "countryCode": "KH",
    "precision": 2
  },
  {
    "code": "XAF",
    "name": "Central African CFA franc",
    "symbol": "FCFA",
    "countryCode": "CM",
    "precision": 0
  },
  {
    "code": "CAD",
    "name": "Canadian dollar",
    "symbol": "$",
    "countryCode": "CA",
    "precision": 2
  },
  {
    "code": "CVE",
    "name": "Cape Verdean escudo",
    "symbol": "$",
    "countryCode": "CV",
    "precision": 2
  },
  {
    "code": "KYD",
    "name": "Cayman Islands dollar",
    "symbol": "$",
    "countryCode": "KY",
    "precision": 2
  },
  {
    "code": "XAF",
    "name": "Central African CFA franc",
    "symbol": "FCFA",
    "countryCode": "CF",
    "precision": 0
  },
  {
    "code": "XAF",
    "name": "Central African CFA franc",
    "symbol": "FCFA",
    "countryCode": "TD",
    "precision": 0
  },
  {
    "code": "CLP",
    "name": "Chilean peso",
    "symbol": "$",
    "countryCode": "CL",
    "precision": 0
  },
  {
    "code": "CNY",
    "name": "Chinese yuan",
    "symbol": "¥",
    "countryCode": "CN",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "CX",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "CC",
    "precision": 2
  },
  {
    "code": "COP",
    "name": "Colombian peso",
    "symbol": "$",
    "countryCode": "CO",
    "precision": 0
  },
  {
    "code": "KMF",
    "name": "Comorian franc",
    "symbol": "CF",
    "countryCode": "KM",
    "precision": 0
  },
  {
    "code": "CDF",
    "name": "Congolese Franc",
    "symbol": "FC",
    "countryCode": "CG",
    "precision": 2
  },
  {
    "code": "NZD",
    "name": "New Zealand dollar",
    "symbol": "$",
    "countryCode": "CK",
    "precision": 2
  },
  {
    "code": "CRC",
    "name": "Costa Rican colón",
    "symbol": "₡",
    "countryCode": "CR",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "HR",
    "precision": 2
  },
  {
    "code": "CUP",
    "name": "Cuban peso",
    "symbol": "$",
    "countryCode": "CU",
    "precision": 2
  },
  {
    "code": "ANG",
    "name": "Netherlands Antillean guilder",
    "symbol": "ƒ",
    "countryCode": "CW",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "CY",
    "precision": 2
  },
  {
    "code": "CZK",
    "name": "Czech koruna",
    "symbol": "Kč",
    "countryCode": "CZ",
    "precision": 2
  },
  {
    "code": "CDF",
    "name": "Congolese Franc",
    "symbol": "FC",
    "countryCode": "CD",
    "precision": 2
  },
  {
    "code": "DKK",
    "name": "Danish krone",
    "symbol": "Kr.",
    "countryCode": "DK",
    "precision": 2
  },
  {
    "code": "DJF",
    "name": "Djiboutian franc",
    "symbol": "Fdj",
    "countryCode": "DJ",
    "precision": 0
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "DM",
    "precision": 2
  },
  {
    "code": "DOP",
    "name": "Dominican peso",
    "symbol": "$",
    "countryCode": "DO",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "EC",
    "precision": 2
  },
  {
    "code": "EGP",
    "name": "Egyptian pound",
    "symbol": "ج.م",
    "countryCode": "EG",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "SV",
    "precision": 2
  },
  {
    "code": "XAF",
    "name": "Central African CFA franc",
    "symbol": "FCFA",
    "countryCode": "GQ",
    "precision": 0
  },
  {
    "code": "ERN",
    "name": "Eritrean nakfa",
    "symbol": "Nfk",
    "countryCode": "ER",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "EE",
    "precision": 2
  },
  {
    "code": "SZL",
    "name": "Lilangeni",
    "symbol": "E",
    "countryCode": "SZ",
    "precision": 2
  },
  {
    "code": "ETB",
    "name": "Ethiopian birr",
    "symbol": "Nkf",
    "countryCode": "ET",
    "precision": 2
  },
  {
    "code": "FKP",
    "name": "Falkland Islands pound",
    "symbol": "£",
    "countryCode": "FK",
    "precision": 2
  },
  {
    "code": "DKK",
    "name": "Danish krone",
    "symbol": "Kr.",
    "countryCode": "FO",
    "precision": 2
  },
  {
    "code": "FJD",
    "name": "Fijian dollar",
    "symbol": "FJ$",
    "countryCode": "FJ",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "FI",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "FR",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "GF",
    "precision": 2
  },
  {
    "code": "XPF",
    "name": "CFP franc",
    "symbol": "₣",
    "countryCode": "PF",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "TF",
    "precision": 2
  },
  {
    "code": "XAF",
    "name": "Central African CFA franc",
    "symbol": "FCFA",
    "countryCode": "GA",
    "precision": 0
  },
  {
    "code": "GEL",
    "name": "Georgian lari",
    "symbol": "ლ",
    "countryCode": "GE",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "DE",
    "precision": 2
  },
  {
    "code": "GHS",
    "name": "Ghanaian cedi",
    "symbol": "GH₵",
    "countryCode": "GH",
    "precision": 2
  },
  {
    "code": "GIP",
    "name": "Gibraltar pound",
    "symbol": "£",
    "countryCode": "GI",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "GR",
    "precision": 2
  },
  {
    "code": "DKK",
    "name": "Danish krone",
    "symbol": "Kr.",
    "countryCode": "GL",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "GD",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "GP",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "GU",
    "precision": 2
  },
  {
    "code": "GTQ",
    "name": "Guatemalan quetzal",
    "symbol": "Q",
    "countryCode": "GT",
    "precision": 2
  },
  {
    "code": "GBP",
    "name": "British pound",
    "symbol": "£",
    "countryCode": "GG",
    "precision": 2
  },
  {
    "code": "GNF",
    "name": "Guinean franc",
    "symbol": "FG",
    "countryCode": "GN",
    "precision": 0
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "GW",
    "precision": 0
  },
  {
    "code": "GYD",
    "name": "Guyanese dollar",
    "symbol": "$",
    "countryCode": "GY",
    "precision": 2
  },
  {
    "code": "HTG",
    "name": "Haitian gourde",
    "symbol": "G",
    "countryCode": "HT",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "HM",
    "precision": 2
  },
  {
    "code": "HNL",
    "name": "Honduran lempira",
    "symbol": "L",
    "countryCode": "HN",
    "precision": 2
  },
  {
    "code": "HKD",
    "name": "Hong Kong dollar",
    "symbol": "$",
    "countryCode": "HK",
    "precision": 2
  },
  {
    "code": "HUF",
    "name": "Hungarian forint",
    "symbol": "Ft",
    "countryCode": "HU",
    "precision": 0
  },
  {
    "code": "ISK",
    "name": "Icelandic króna",
    "symbol": "ko",
    "countryCode": "IS",
    "precision": 0
  },
  {
    "code": "INR",
    "name": "Indian rupee",
    "symbol": "₹",
    "countryCode": "IN",
    "precision": 2
  },
  {
    "code": "IDR",
    "name": "Indonesian rupiah",
    "symbol": "Rp",
    "countryCode": "ID",
    "precision": 0
  },
  {
    "code": "IRR",
    "name": "Iranian rial",
    "symbol": "﷼",
    "countryCode": "IR",
    "precision": 0
  },
  {
    "code": "IQD",
    "name": "Iraqi dinar",
    "symbol": "د.ع",
    "countryCode": "IQ",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "IE",
    "precision": 2
  },
  {
    "code": "ILS",
    "name": "Israeli new shekel",
    "symbol": "₪",
    "countryCode": "IL",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "IT",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "CI",
    "precision": 0
  },
  {
    "code": "JMD",
    "name": "Jamaican dollar",
    "symbol": "J$",
    "countryCode": "JM",
    "precision": 2
  },
  {
    "code": "JPY",
    "name": "Japanese yen",
    "symbol": "¥",
    "countryCode": "JP",
    "precision": 0
  },
  {
    "code": "GBP",
    "name": "British pound",
    "symbol": "£",
    "countryCode": "JE",
    "precision": 2
  },
  {
    "code": "JOD",
    "name": "Jordanian dinar",
    "symbol": "ا.د",
    "countryCode": "JO",
    "precision": 3
  },
  {
    "code": "KZT",
    "name": "Kazakhstani tenge",
    "symbol": "лв",
    "countryCode": "KZ",
    "precision": 2
  },
  {
    "code": "KES",
    "name": "Kenyan shilling",
    "symbol": "KSh",
    "countryCode": "KE",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "KI",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "XK",
    "precision": 2
  },
  {
    "code": "KWD",
    "name": "Kuwaiti dinar",
    "symbol": "ك.د",
    "countryCode": "KW",
    "precision": 3
  },
  {
    "code": "KGS",
    "name": "Kyrgyzstani som",
    "symbol": "лв",
    "countryCode": "KG",
    "precision": 2
  },
  {
    "code": "LAK",
    "name": "Lao kip",
    "symbol": "₭",
    "countryCode": "LA",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "LV",
    "precision": 2
  },
  {
    "code": "LBP",
    "name": "Lebanese pound",
    "symbol": "£",
    "countryCode": "LB",
    "precision": 0
  },
  {
    "code": "LSL",
    "name": "Lesotho loti",
    "symbol": "L",
    "countryCode": "LS",
    "precision": 2
  },
  {
    "code": "LRD",
    "name": "Liberian dollar",
    "symbol": "$",
    "countryCode": "LR",
    "precision": 2
  },
  {
    "code": "LYD",
    "name": "Libyan dinar",
    "symbol": "د.ل",
    "countryCode": "LY",
    "precision": 3
  },
  {
    "code": "CHF",
    "name": "Swiss franc",
    "symbol": "CHf",
    "countryCode": "LI",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "LT",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "LU",
    "precision": 2
  },
  {
    "code": "MOP",
    "name": "Macanese pataca",
    "symbol": "$",
    "countryCode": "MO",
    "precision": 2
  },
  {
    "code": "MGA",
    "name": "Malagasy ariary",
    "symbol": "Ar",
    "countryCode": "MG",
    "precision": 0
  },
  {
    "code": "MWK",
    "name": "Malawian kwacha",
    "symbol": "MK",
    "countryCode": "MW",
    "precision": 2
  },
  {
    "code": "MYR",
    "name": "Malaysian ringgit",
    "symbol": "RM",
    "countryCode": "MY",
    "precision": 2
  },
  {
    "code": "MVR",
    "name": "Maldivian rufiyaa",
    "symbol": "Rf",
    "countryCode": "MV",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "ML",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "MT",
    "precision": 2
  },
  {
    "code": "GBP",
    "name": "British pound",
    "symbol": "£",
    "countryCode": "IM",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "MH",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "MQ",
    "precision": 2
  },
  {
    "code": "MRU",
    "name": "Mauritanian ouguiya",
    "symbol": "UM",
    "countryCode": "MR",
    "precision": 2
  },
  {
    "code": "MUR",
    "name": "Mauritian rupee",
    "symbol": "₨",
    "countryCode": "MU",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "YT",
    "precision": 2
  },
  {
    "code": "MXN",
    "name": "Mexican peso",
    "symbol": "$",
    "countryCode": "MX",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "FM",
    "precision": 2
  },
  {
    "code": "MDL",
    "name": "Moldovan leu",
    "symbol": "L",
    "countryCode": "MD",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "MC",
    "precision": 2
  },
  {
    "code": "MNT",
    "name": "Mongolian tögrög",
    "symbol": "₮",
    "countryCode": "MN",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "ME",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "MS",
    "precision": 2
  },
  {
    "code": "MAD",
    "name": "Moroccan dirham",
    "symbol": "DH",
    "countryCode": "MA",
    "precision": 2
  },
  {
    "code": "MZN",
    "name": "Mozambican metical",
    "symbol": "MT",
    "countryCode": "MZ",
    "precision": 2
  },
  {
    "code": "MMK",
    "name": "Burmese kyat",
    "symbol": "K",
    "countryCode": "MM",
    "precision": 0
  },
  {
    "code": "NAD",
    "name": "Namibian dollar",
    "symbol": "$",
    "countryCode": "NA",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "NR",
    "precision": 2
  },
  {
    "code": "NPR",
    "name": "Nepalese rupee",
    "symbol": "₨",
    "countryCode": "NP",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "NL",
    "precision": 2
  },
  {
    "code": "XPF",
    "name": "CFP franc",
    "symbol": "₣",
    "countryCode": "NC",
    "precision": 0
  },
  {
    "code": "NZD",
    "name": "New Zealand dollar",
    "symbol": "$",
    "countryCode": "NZ",
    "precision": 2
  },
  {
    "code": "NIO",
    "name": "Nicaraguan córdoba",
    "symbol": "C$",
    "countryCode": "NI",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "NE",
    "precision": 0
  },
  {
    "code": "NGN",
    "name": "Nigerian naira",
    "symbol": "₦",
    "countryCode": "NG",
    "precision": 2
  },
  {
    "code": "NZD",
    "name": "New Zealand dollar",
    "symbol": "$",
    "countryCode": "NU",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "NF",
    "precision": 2
  },
  {
    "code": "KPW",
    "name": "North Korean Won",
    "symbol": "₩",
    "countryCode": "KP",
    "precision": 0
  },
  {
    "code": "MKD",
    "name": "Denar",
    "symbol": "ден",
    "countryCode": "MK",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "MP",
    "precision": 2
  },
  {
    "code": "NOK",
    "name": "Norwegian krone",
    "symbol": "ko",
    "countryCode": "NO",
    "precision": 2
  },
  {
    "code": "OMR",
    "name": "Omani rial",
    "symbol": ".ع.ر",
    "countryCode": "OM",
    "precision": 3
  },
  {
    "code": "PKR",
    "name": "Pakistani rupee",
    "symbol": "₨",
    "countryCode": "PK",
    "precision": 0
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "PW",
    "precision": 2
  },
  {
    "code": "ILS",
    "name": "Israeli new shekel",
    "symbol": "₪",
    "countryCode": "PS",
    "precision": 2
  },
  {
    "code": "PAB",
    "name": "Panamanian balboa",
    "symbol": "B/.",
    "countryCode": "PA",
    "precision": 2
  },
  {
    "code": "PGK",
    "name": "Papua New Guinean kina",
    "symbol": "K",
    "countryCode": "PG",
    "precision": 2
  },
  {
    "code": "PYG",
    "name": "Paraguayan guarani",
    "symbol": "₲",
    "countryCode": "PY",
    "precision": 0
  },
  {
    "code": "PEN",
    "name": "Peruvian sol",
    "symbol": "S/.",
    "countryCode": "PE",
    "precision": 2
  },
  {
    "code": "PHP",
    "name": "Philippine peso",
    "symbol": "₱",
    "countryCode": "PH",
    "precision": 2
  },
  {
    "code": "NZD",
    "name": "New Zealand dollar",
    "symbol": "$",
    "countryCode": "PN",
    "precision": 2
  },
  {
    "code": "PLN",
    "name": "Polish złoty",
    "symbol": "zł",
    "countryCode": "PL",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "PT",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "PR",
    "precision": 2
  },
  {
    "code": "QAR",
    "name": "Qatari riyal",
    "symbol": "ق.ر",
    "countryCode": "QA",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "RE",
    "precision": 2
  },
  {
    "code": "RON",
    "name": "Romanian leu",
    "symbol": "lei",
    "countryCode": "RO",
    "precision": 2
  },
  {
    "code": "RUB",
    "name": "Russian ruble",
    "symbol": "₽",
    "countryCode": "RU",
    "precision": 2
  },
  {
    "code": "RWF",
    "name": "Rwandan franc",
    "symbol": "FRw",
    "countryCode": "RW",
    "precision": 0
  },
  {
    "code": "SHP",
    "name": "Saint Helena pound",
    "symbol": "£",
    "countryCode": "SH",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "KN",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "LC",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "PM",
    "precision": 2
  },
  {
    "code": "XCD",
    "name": "Eastern Caribbean dollar",
    "symbol": "$",
    "countryCode": "VC",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "BL",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "MF",
    "precision": 2
  },
  {
    "code": "WST",
    "name": "Samoan tālā",
    "symbol": "SAT",
    "countryCode": "WS",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "SM",
    "precision": 2
  },
  {
    "code": "STN",
    "name": "Dobra",
    "symbol": "Db",
    "countryCode": "ST",
    "precision": 2
  },
  {
    "code": "SAR",
    "name": "Saudi riyal",
    "symbol": "﷼",
    "countryCode": "SA",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "SN",
    "precision": 0
  },
  {
    "code": "RSD",
    "name": "Serbian dinar",
    "symbol": "din",
    "countryCode": "RS",
    "precision": 2
  },
  {
    "code": "SCR",
    "name": "Seychellois rupee",
    "symbol": "SRe",
    "countryCode": "SC",
    "precision": 2
  },
  {
    "code": "SLL",
    "name": "Sierra Leonean leone",
    "symbol": "Le",
    "countryCode": "SL",
    "precision": 0
  },
  {
    "code": "SGD",
    "name": "Singapore dollar",
    "symbol": "$",
    "countryCode": "SG",
    "precision": 2
  },
  {
    "code": "ANG",
    "name": "Netherlands Antillean guilder",
    "symbol": "ƒ",
    "countryCode": "SX",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "SK",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "SI",
    "precision": 2
  },
  {
    "code": "SBD",
    "name": "Solomon Islands dollar",
    "symbol": "Si$",
    "countryCode": "SB",
    "precision": 2
  },
  {
    "code": "SOS",
    "name": "Somali shilling",
    "symbol": "Sh.so.",
    "countryCode": "SO",
    "precision": 0
  },
  {
    "code": "ZAR",
    "name": "South African rand",
    "symbol": "R",
    "countryCode": "ZA",
    "precision": 2
  },
  {
    "code": "GBP",
    "name": "British pound",
    "symbol": "£",
    "countryCode": "GS",
    "precision": 2
  },
  {
    "code": "KRW",
    "name": "Won",
    "symbol": "₩",
    "countryCode": "KR",
    "precision": 0
  },
  {
    "code": "SSP",
    "name": "South Sudanese pound",
    "symbol": "£",
    "countryCode": "SS",
    "precision": 2
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "ES",
    "precision": 2
  },
  {
    "code": "LKR",
    "name": "Sri Lankan rupee",
    "symbol": "Rs",
    "countryCode": "LK",
    "precision": 2
  },
  {
    "code": "SDG",
    "name": "Sudanese pound",
    "symbol": ".س.ج",
    "countryCode": "SD",
    "precision": 2
  },
  {
    "code": "SRD",
    "name": "Surinamese dollar",
    "symbol": "$",
    "countryCode": "SR",
    "precision": 2
  },
  {
    "code": "NOK",
    "name": "Norwegian krone",
    "symbol": "ko",
    "countryCode": "SJ",
    "precision": 2
  },
  {
    "code": "SEK",
    "name": "Swedish krona",
    "symbol": "ko",
    "countryCode": "SE",
    "precision": 2
  },
  {
    "code": "CHF",
    "name": "Swiss franc",
    "symbol": "CHf",
    "countryCode": "CH",
    "precision": 2
  },
  {
    "code": "SYP",
    "name": "Syrian pound",
    "symbol": "LS",
    "countryCode": "SY",
    "precision": 0
  },
  {
    "code": "TWD",
    "name": "New Taiwan dollar",
    "symbol": "$",
    "countryCode": "TW",
    "precision": 2
  },
  {
    "code": "TJS",
    "name": "Tajikistani somoni",
    "symbol": "SM",
    "countryCode": "TJ",
    "precision": 2
  },
  {
    "code": "TZS",
    "name": "Tanzanian shilling",
    "symbol": "TSh",
    "countryCode": "TZ",
    "precision": 2
  },
  {
    "code": "THB",
    "name": "Thai baht",
    "symbol": "฿",
    "countryCode": "TH",
    "precision": 2
  },
  {
    "code": "BSD",
    "name": "Bahamian dollar",
    "symbol": "B$",
    "countryCode": "BS",
    "precision": 2
  },
  {
    "code": "GMD",
    "name": "Gambian dalasi",
    "symbol": "D",
    "countryCode": "GM",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "TL",
    "precision": 2
  },
  {
    "code": "XOF",
    "name": "West African CFA franc",
    "symbol": "CFA",
    "countryCode": "TG",
    "precision": 0
  },
  {
    "code": "NZD",
    "name": "New Zealand dollar",
    "symbol": "$",
    "countryCode": "TK",
    "precision": 2
  },
  {
    "code": "TOP",
    "name": "Tongan paʻanga",
    "symbol": "$",
    "countryCode": "TO",
    "precision": 2
  },
  {
    "code": "TTD",
    "name": "Trinidad and Tobago dollar",
    "symbol": "$",
    "countryCode": "TT",
    "precision": 2
  },
  {
    "code": "TND",
    "name": "Tunisian dinar",
    "symbol": "ت.د",
    "countryCode": "TN",
    "precision": 3
  },
  {
    "code": "TRY",
    "name": "Turkish lira",
    "symbol": "₺",
    "countryCode": "TR",
    "precision": 2
  },
  {
    "code": "TMT",
    "name": "Turkmenistan manat",
    "symbol": "T",
    "countryCode": "TM",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "TC",
    "precision": 2
  },
  {
    "code": "AUD",
    "name": "Australian dollar",
    "symbol": "$",
    "countryCode": "TV",
    "precision": 2
  },
  {
    "code": "UGX",
    "name": "Ugandan shilling",
    "symbol": "USh",
    "countryCode": "UG",
    "precision": 0
  },
  {
    "code": "UAH",
    "name": "Ukrainian hryvnia",
    "symbol": "₴",
    "countryCode": "UA",
    "precision": 2
  },
  {
    "code": "AED",
    "name": "United Arab Emirates dirham",
    "symbol": "إ.د",
    "countryCode": "AE",
    "precision": 2
  },
  {
    "code": "GBP",
    "name": "British pound",
    "symbol": "£",
    "countryCode": "GB",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "US",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "UM",
    "precision": 2
  },
  {
    "code": "UYU",
    "name": "Uruguayan peso",
    "symbol": "$",
    "countryCode": "UY",
    "precision": 2
  },
  {
    "code": "UZS",
    "name": "Uzbekistani soʻm",
    "symbol": "лв",
    "countryCode": "UZ",
    "precision": 2
  },
  {
    "code": "VUV",
    "name": "Vanuatu vatu",
    "symbol": "VT",
    "countryCode": "VU",
    "precision": 0
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "VA",
    "precision": 2
  },
  {
    "code": "VES",
    "name": "Bolívar",
    "symbol": "Bs",
    "countryCode": "VE",
    "precision": 2
  },
  {
    "code": "VND",
    "name": "Vietnamese đồng",
    "symbol": "₫",
    "countryCode": "VN",
    "precision": 0
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "VG",
    "precision": 2
  },
  {
    "code": "USD",
    "name": "United States dollar",
    "symbol": "$",
    "countryCode": "VI",
    "precision": 2
  },
  {
    "code": "XPF",
    "name": "CFP franc",
    "symbol": "₣",
    "countryCode": "WF",
    "precision": 0
  },
  {
    "code": "MAD",
    "name": "Moroccan dirham",
    "symbol": "DH",
    "countryCode": "EH",
    "precision": 2
  },
  {
    "code": "YER",
    "name": "Yemeni rial",
    "symbol": "﷼",
    "countryCode": "YE",
    "precision": 0
  },
  {
    "code": "ZMW",
    "name": "Zambian kwacha",
    "symbol": "ZK",
    "countryCode": "ZM",
    "precision": 2
  },
  {
    "code": "ZWL",
    "name": "Zimbabwe Dollar",
    "symbol": "$",
    "countryCode": "ZW",
    "precision": 2
  }
];

export default CURRENCIES;
